import React from "react";
import styled from "styled-components";
import SocialIcons from "../SocialIcons/SocialIcons";
import { Link, useNavigate } from "react-router-dom";
import Wrapper from "../Wrapper/Wrapper";

// Styled Components
const FooterContainer = styled.div`
  width: 100%;
  background-color: #cc0000;
  color: white;
  padding: 2em 0 1em;

    @media (max-width: 768px) {
  }
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr; /* Tre colonne */
  gap: 2em; /* Spaziatura tra le colonne */

  @media (max-width: 768px) {
    grid-template-columns: 1fr; /* Disposizione a colonna per dispositivi mobili */
    text-align: center;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    justify-content: center;
  }

  img {
    cursor: pointer;
    width: 65%;
    height: auto;
  }
`;

const FollowSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const LinkSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  a {
    color: white;
    text-decoration: none;
    margin-bottom: 0.5em;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const BottomText = styled.div`
  text-align: center;
  margin-top: 2em;

  p {
    margin: 0;
  }
`;

export const Divider = styled.div`
  height: 1px;
  width: 50px;
  background-color: white;
  margin: 1em 0px;
`;

const logo = "https://rossomotori.it/wp-content/uploads/2025/03/footer.png";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <FooterContainer>
      <Wrapper padding={'0 1rem'}>
        <FooterContent>
          {/* Logo Section */}
          <LogoWrapper>
            <img
              src={logo}
              alt="logo"
              onClick={() => navigate("/")}
            />
          </LogoWrapper>

          {/* Follow Section */}
          <FollowSection>
            <p style={{color:'white'}}>Seguici</p>
            <SocialIcons isFooter={true}/>
          </FollowSection>

          {/* Links Section */}
          <LinkSection>
            <Link to="/team"><p style={{color: 'white', margin:'0 10px'}}>Chi siamo</p></Link>
            <Link to="/contact-us"><p style={{color: 'white', margin:'0 10px'}}>Contattaci</p></Link>
            <Link to="/terms&Conditions"><p style={{color: 'white', margin:'0 10px'}}>Termini & Condizioni</p></Link>
            <Link to="/cookie-policy"><p style={{color: 'white', margin:'0 10px'}}>Cookie policy</p></Link>
            <Link to="/privacy-policy"><p style={{color: 'white', margin:'0 10px'}}>Privacy policy</p></Link>
            <Link to="/cookie-settings"><p style={{color: 'white', margin:'0 10px'}}>Cookie settings</p></Link>
          </LinkSection>
        </FooterContent>
      </Wrapper>

      {/* Bottom Text */}
      <BottomText>
        <p style={{color:'white'}}>© 2025 Rossomotori.it. Tutti i diritti riservati.</p>
        <div style={{marginTop:'0.3em'}}>
        <Link to='https://www.linkedin.com/in/andreafrangeamore/' style={{textDecoration:'none'}}>
        <p style={{color:'white'}}>Sviluppato da Andrea Frangeamore 👨‍💻</p>
        </Link>
        </div>
      </BottomText>
    </FooterContainer>
  );
};

export default Footer;
